import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEEXPENDITURE = gql`
  mutation removeExpenditure($id: ID!) {
    removeExpenditure(id: $id)
  }
`;

function DeleteExpenditure({ id, children, onDeleteExpenditure, closeDrawer }) {
  const [runDeleteExpenditure, deleteExpenditure] = useMutation(DELETEEXPENDITURE, {
    onCompleted({ removeExpenditure }) {
  
      if (removeExpenditure) {
        message.success(`هزینه جانبی حذف شد.`);
        onDeleteExpenditure();
        closeDrawer();
      }
    },
    onError(err) {
      console.log(err.message);
    },
  });

  const doDeleteExpenditure= () => {
    runDeleteExpenditure({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={"حذف هزینه جانبی؟"}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteExpenditure}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteExpenditure;
